<template lang="pug">
  #result
    p
      | Toma aê seu link:
      a#result-link(:href='result' target='_blank') {{ result }}
      button(
        v-tooltip.bottom="copyMsg"
        v-clipboard:copy="result"
        @click="copy"
        @mouseleave="resetMsg"
      )
        font-awesome-icon(:icon="['far', 'copy']")
    router-link(to="/") Encurtar outro link
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Result',
  components: {
    FontAwesomeIcon
  },
  props: ['id'],
  data () {
    return {
      copyMsg: 'Clique para copiar'
    }
  },
  computed: {
    result () {
      return `${process.env.APP_URL}/${this.id}`
    }
  },
  methods: {
    copy () {
      this.copyMsg = 'Copiado!'
    },
    resetMsg () {
      this.copyMsg = 'Clique para copiar'
    }
  }
}
</script>

<style lang="stylus" scoped>
a
  color lighten(#2c3e50, 30%)
  margin .8em

button
  background none
  border none
  cursor pointer
  padding .4em .7em
  border-radius 50%
  &:hover
    background-color darken(white, 5%)
</style>



// WEBPACK FOOTER //
// src/components/Result.vue